import React, { useContext, useEffect, useState } from 'react'
import { jwtDecode } from "jwt-decode";
import moment from 'moment'
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider'
import { OrderDataProviderContext } from '../../context-api/data-provider/OrderDataProvider'
import { localStorageKeys, orderStatusMapping } from '../../utils/constants'
import RunCircleIcon from '@mui/icons-material/RunCircle'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import DoneIcon from '@mui/icons-material/Done';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import './dashboard.scss'
import SelectBox from '../../atomic/selectbox/SelectBox'
import { isMobile, isIpad, isDesktop } from '../../utils/ScreenSizeHelper';
import TextTransformation from '../../utils/textTransformation'
import AtomicButton from '../../atomic/button/Button'
import TransactionDetail from './TransactionDetail';
import { getFriendlyDateLabel } from '../../utils/dateFormat';
import { DisplayIcon } from '../../utils/DisplayIcons'

const AllOrders = () => {
    const {
        allOrders,
        setAllOrders,
    } = useContext(GlobalStateDataContext)

    const {
        clickedAllOrders,
        setClickedAllOrders,
        selectedDate,
        setSelectedDate,
        FetchOrders,
        onGetOrders,
        currentDate
    } = useContext(OrderDataProviderContext)

    const [filteredOrders, setFilteredOrders] = useState(allOrders)
    const [selectedFilter, setSelectedFilter] = useState('all orders');
    const [startNo, endNo] = (clickedAllOrders?.order_no || '').split('-')
    const isMealOrder = endNo?.includes('MEAL')

    const { REFRESH_TOKEN, TOKEN } = localStorageKeys;
    const hasTokens = localStorage.getItem(TOKEN);

    let KitchenName = null
    if (hasTokens) {
        const decodedToken = jwtDecode(hasTokens);
        const { email, kitchenName } = decodedToken || null;
        KitchenName = kitchenName

    }


    const FetchOrdersDirect = async (date) => {

        setAllOrders([])
        const payload = {
            date: moment(date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
            kitchen_name: KitchenName,
            order_history: false,
        }
        const OrderData = await onGetOrders(payload)

        if (OrderData?.joinedOrders?.length > 0) {
            OrderData?.joinedOrders?.forEach((order) => {
                const OrderInformation = {
                    ...order.payAsYouGoOrder,
                    order_no: (order.payAsYouGoOrder?.joined_order_no) ? order.payAsYouGoOrder?.joined_order_no : order.payAsYouGoOrder?.order_no,
                    item_names: [...(order.payAsYouGoOrder?.item_names || []),
                    ...(order.mealOrder?.item_name || [])],

                }

                setAllOrders(prev => ([
                    ...prev,
                    OrderInformation
                ]))

            })
        }


        if (OrderData?.payAsYouGoOrders?.length > 0) {
            OrderData?.payAsYouGoOrders?.forEach((order) => {
                setAllOrders(prev => ([
                    ...prev,
                    order
                ]))
            })
        }



        if (OrderData?.mealOrders?.length > 0) {
            OrderData?.mealOrders?.forEach((order) => {
                setAllOrders(prev => ([
                    ...prev,
                    order
                ]))
            })
        }

        if (OrderData?.PromotionalOrders?.length > 0) {
            OrderData?.PromotionalOrders?.forEach((order) => {
                setAllOrders(prev => ([
                    ...prev,
                    order
                ]))
            })
        }
    }


    const StyleTotalBlock = {
        fontFamily: 'Inter Medium',
        fontSize: '15px'
    }


    const StyleNumberBlock = {

        fontFamily: 'Inter Medium',
        fontSize: '15px'
    }

    const ColorLabel = (status) => {

        if (status === 'order delivered') {
            return {
                border: '1px solid #328E6E',
                color: 'white',
                backgroundColor: '#67AE6E',
                padding: '5px'
            }
        }

        if (status === 'order canceled by kitchen') {
            return {
                border: '1px solid #A62C2C',
                color: 'white',
                backgroundColor: '#E83F25',
                padding: '5px'
            }
        }

        if (status === 'driver is at the door') {
            return {
                border: '1px solid lightgary',
                color: '#0E2148',
                backgroundColor: '#F2F2F2',
                padding: '5px'
            }
        }


        if (status === 'order canceled by customer') {
            return {
                border: '1px solid #A62C2C',
                color: 'white',
                backgroundColor: '#E83F25',
                padding: '5px'
            }
        }


        if (status === 'order_damaged_while_delivery') {
            return {
                border: '1px solid #A62C2C',
                color: 'white',
                backgroundColor: '#FF6363',
                padding: '5px'
            }
        }

        if (status === 'order accepted by kitchen') {
            return {
                border: '1px solid #AFFD586',
                color: 'black',
                backgroundColor: '#FFE99A',
                padding: '5px'
            }
        }

        if (status === 'order ready for pickup') {
            return {
                border: '1px solid #81E7AF',
                color: '#1E3E62',
                backgroundColor: '#81E7AF',
                padding: '5px'
            }
        }

    }



    const promoTypeLabel = (discount_type, discountedAmount) => {
        // You have to create paths on app.js before coming here to add tan name
        switch (discount_type) {
            case 'percentage':
                return `${discountedAmount}% off`;
            case 'plates':
                return `${discountedAmount} Free meal`;
            case 'amount_off':
                return `- $${discountedAmount} off`;
            case 'product':
                return `- $${discountedAmount} off`;
            case 'free_delivery':
                return `- $${discountedAmount} Delivery off`;
            case 'percentage_delivery':
                return `${discountedAmount}% Delivery off`;
            case 'free':
                return `Free order`;

        }
    }



    const onStatusChange = (value) => {

        setClickedAllOrders({})

        if (value === 'all orders') {
            setFilteredOrders(allOrders)
        }
        else {
            const filteredOrders = allOrders.filter(item => {
                return item.internal_order_status === value
            })

            setFilteredOrders(filteredOrders)
        }
        setSelectedFilter(value)
    }


    useEffect(() => {
        FetchOrdersDirect(selectedDate)
    }, [])



    useEffect(() => {
        if (selectedFilter === 'all orders') {
            setFilteredOrders(allOrders)
        }
        else {
            const filteredOrders = allOrders.filter(item => {
                return item.internal_order_status === selectedFilter
            })

            setFilteredOrders(filteredOrders)
        }
    }, [JSON.stringify(allOrders)]);



    useEffect(() => {

        setClickedAllOrders({})

    }, [selectedDate])



    // Display time // e.g. "08:34 AM"
    function TimeDisplay(isoTime) {
        const time = new Date(isoTime).toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
        return time;
    }


    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'row', margin: '20px 5px 15px 5px' }}>
                <div style={{ marginRight: '10px' }} className='date-picker-filter'>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                            label='Filter By Date'
                            name='filter_date'
                            onChange={value => {
                                FetchOrdersDirect(value)
                                setSelectedDate(value);
                            }}
                            value={selectedDate}
                            format='MM/DD/YYYY'
                        />
                    </LocalizationProvider>
                </div>
                <div className="status-filter">
                    <SelectBox
                        sx={{
                            minWidth: 220,
                            height: "auto",
                            margin: "10px 5px 5px 0px",
                        }}
                        label="Filter By Order Status"
                        value={selectedFilter}
                        onChange={onStatusChange}
                        options={['all orders', 'driver picked the order',
                            'order canceled by customer',
                            'order_damaged_while_delivery',
                            'driver is at the door', 'order delivered',
                            'order accepted by kitchen', 'order ready for pickup',
                            'driver pickup pending',
                            'order canceled by kitchen']}
                    />
                </div>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    marginLeft: '20px',
                    border: '1px solid black',
                    padding: '2px 10px 2px 10px',
                    borderRadius: '3px'
                }}>
                    <div style={{ fontSize: '12px', fontFamily: 'Inter Regular', color: 'gray' }}> Total Order</div>
                    <div style={{ fontSize: '14px', fontFamily: 'Inter Bold' }}>{filteredOrders?.length}</div>
                </div>
            </div>

            <div style={{ display: 'flex', height: '91vh' }}>
                <div style={{ width: '32%', borderRight: '1px solid #ccd0d5', borderTop: '1px solid #ccd0d5' }}>
                    {filteredOrders.map(item => {
                        const [startNo, endNo] = item.order_no.split('-')
                        const totalItems = item?.item_names?.length
                        const mealTotalItems = item?.item_name?.length

                        return (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    // alignItems: 'center',
                                    border: '1px solid #0E2148',
                                    height: 'auto',
                                    borderRadius: '3px',
                                    margin: '4px',
                                    padding: '10px',
                                    // backgroundColor: '#A8F1FF',
                                    color: 'white',
                                    cursor: 'pointer'
                                }}
                                onClick={() => {
                                    setClickedAllOrders(item)
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between'
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: '16px',
                                            fontFamily: 'Inter Bold',
                                            textTransform: 'capitalize',
                                            letterSpacing: '0.5px',
                                            color: '#332D56'
                                        }}
                                    >
                                        {' '}
                                        {item.cust_firstName}
                                    </div>
                                    <div
                                        style={{
                                            border: '2px solid #0E2148',
                                            color: 'white',
                                            backgroundColor: '#0E2148',
                                            fontSize: '12px',
                                            borderRadius: '3px',
                                            padding: '2px 5px 2px 5px',
                                            ...ColorLabel(item.internal_order_status)
                                        }}
                                    >
                                        {orderStatusMapping[item.internal_order_status]}
                                    </div>
                                </div>


                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        marginTop: '3px'
                                    }}
                                >
                                    <div
                                        style={{
                                            fontFamily: 'Inter Regular',
                                            fontSize: '14px',
                                            color: '#332D56'
                                        }}
                                    >
                                        {' '}
                                        {`# ${endNo}`}
                                    </div>
                                    <div
                                        style={{
                                            fontFamily: 'Inter Regular',
                                            fontSize: '14px',
                                            color: '#332D56'
                                        }}
                                    >
                                        {' '}
                                        {totalItems || mealTotalItems}{' '}
                                        {totalItems === 1 || mealTotalItems === 1
                                            ? 'item'
                                            : 'items'}{' '}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>


                {Object.keys(clickedAllOrders).length > 0 &&
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '65%',
                        backgroundColor: 'white',
                        borderLeft: '1px solid #ccd0d5',
                        borderTop: '1px solid #ccd0d5',
                        padding: '10px'

                    }}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                        }}>

                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}>

                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <div style={{
                                        textTransform: 'capitalize',
                                        color: 'rgb(24, 20, 54',
                                        fontSize: '18px',
                                        fontFamily: 'Inter Bold',
                                    }}>
                                        {clickedAllOrders?.cust_firstName}
                                    </div>

                                    {DisplayIcon({ item: clickedAllOrders, KitchenName: KitchenName, color: 'none' })}

                                </div>

                                <div style={{ fontSize: '14px', }}>{endNo} </div>

                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div style={{ fontFamily: 'Inter Regular', fontSize: '14px' }}> Date</div>
                                <div style={{ fontFamily: 'Inter Bold', fontSize: '14px', }}> {getFriendlyDateLabel(clickedAllOrders?.delivery_date)}</div>
                            </div>


                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }}>

                                {clickedAllOrders?.delivery_type === 'home delivery' && <a style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                                    <LocalShippingIcon sx={{ color: '#181436', fontSize: '25px', margin: '0px 5px 0px 0px' }} />  <a style={{ fontSize: '15px' }}>Home Delivery</a>
                                </a>}


                                {clickedAllOrders?.delivery_type === 'pickup' && <a style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                                    <RunCircleIcon sx={{ color: '#181436', fontSize: '25px', margin: '0px 5px 0px 0px' }} />  <a style={{ fontSize: '15px' }}>Pickup</a>
                                </a>}

                            </div>
                        </div>


                        {clickedAllOrders?.internal_order_status === "order delivered" && <AtomicButton
                            label={`Delivered at ${TimeDisplay(clickedAllOrders?.driver_information?.order_delivered_time)}`}
                            // handleSubmit={() => { console.log('----btn all orders') }}
                            style={{
                                backgroundColor: 'white',
                                width: 'auto',
                                height: '30px',
                                marginTop: '10px',
                                color: 'green',
                                border: '1px solid #1E3E62',

                            }}
                            loading={false}
                            disabled={false}
                            startIcon={<DoneIcon style={{ color: 'green' }} />}
                        />
                        }


                        {clickedAllOrders?.internal_order_status !== "order delivered" && <AtomicButton
                            label={`${clickedAllOrders?.internal_order_status}`}
                            // handleSubmit={() => { console.log('----btn all orders') }}
                            style={{
                                backgroundColor: 'white',
                                width: 'auto',
                                height: '30px',
                                marginTop: '10px',
                                color: '#1E3E62',
                                textTransform: 'capitalize',
                                border: '1px solid #1E3E62',

                            }}
                            loading={false}
                            disabled={false}

                        />
                        }




                        {isMealOrder === false && Object.keys(clickedAllOrders).length > 0 && (
                            <div style={{ marginTop: '20px', width: '80%', marginLeft: '30px' }}>
                                <div style={{ marginLeft: '10px', fontFamily: 'Roboto', fontSize: '14px', color: '#929293', }}>
                                    Item{clickedAllOrders?.item_names?.length > 1 ? 's' : ''}
                                </div>
                                <div style={{ margin: '10px 10px 10px 15px', alignContent: 'center' }}>
                                    {clickedAllOrders?.item_names?.map((item, i) => {

                                        let price = 'Meal item'
                                        let isMealItem = false

                                        if (item?.price) {
                                            price = item.qty * item.price;
                                        }

                                        {/* if (item?.mealItemPrice) {
                                        price = item?.mealItemPrice

                                    } */}

                                        if (item?.product_category) {
                                            isMealItem = true
                                        }


                                        const displayPrice = (price === 'Meal item') ? 'Meal item' : `$${price}`;

                                        if (item?.promotion === 'buy_one_get_one_free' && price !== 'Meal item' && item.qty > 1) {
                                            price = (item.qty - Math.floor(item.qty / 2)) * item.price;
                                        } else if (item?.promotion === 'buy_two_get_one_free' && price !== 'Meal item' && item.qty > 2) {
                                            price = (item.qty - Math.floor(item.qty / 3)) * item.price;
                                        } else if (item?.promotion === 'buy_one_get_half_price' && price !== 'Meal item' && item.qty > 1) {
                                            price = ((item.qty - Math.floor(item.qty / 2)) + (Math.floor(item.qty / 2) / 2)) * item.price;
                                        }

                                        return (
                                            <div style={{ alignContent: 'center', marginBottom: '10px' }} key={`${item}_${i}`}>
                                                <div style={{ display: 'flex', flexDirection: 'row', alignText: 'center', alignContent: 'center' }}>

                                                    <div style={{
                                                        display: 'flex', fontFamily: 'Roboto Medium', fontSize: '11px', justifyContent: 'center', backgroundColor: '#e8e7e9', alignItems: 'center',
                                                        border: '1px solid #c7c7c7', borderRadius: '3px', height: '18px', width: '22px', margin: '0px 10px 5px 0px',
                                                    }}>{item.qty}</div>
                                                    <div style={{ display: 'flex', flexDirection: 'column', }}>
                                                        <div style={{ fontFamily: 'Roboto Medium', fontSize: '16px', color: '#181436', textTransform: 'capitalize', letterSpacing: '0.5px' }}>{item.item}</div>
                                                        {item?.promotion && <div style={{ fontFamily: 'Roboto Regular', fontSize: '13px', color: '#BABABA', marginTop: '2px', marginBottom: '5px' }}>
                                                            Applied - <a style={{ fontFamily: 'Roboto Medium', fontSize: '13px', color: 'rgb(69, 165, 23)' }}> {TextTransformation(item?.promotion)}</a></div>}
                                                        {isMealItem && <div style={{ fontSize: '12px', fontFamily: 'Inter Regular', color: 'lightgray' }}> Meal item</div>}
                                                    </div>
                                                    <div style={{ flex: 1, textAlign: 'right', fontFamily: 'Roboto Medium', fontSize: '14px', color: '#181436', }}> {displayPrice}</div>

                                                </div>
                                                {item?.extra_toppings?.map((t, j) => (
                                                    <div style={{ display: 'flex', flexDirection: 'row', margin: '0px 0px 0px 35px', }} key={t.topping_name}>
                                                        <div style={{ fontFamily: 'Roboto Regular', fontSize: '13px', color: '#181436', marginRight: '30px', textTransform: 'capitalize', letterSpacing: '0.5px' }}>{`${t.topping_name} (${t.topping_qty})`}</div>
                                                        <div style={{ fontFamily: 'Roboto Regular', fontSize: '13px', color: '#181436', marginRight: '10px' }}>${(t.topping_qty * t.price).toFixed(2)}</div>

                                                    </div>
                                                ))}
                                            </div>


                                        );
                                    })}
                                </div>
                            </div>
                        )}


                        {isMealOrder === true && Object.keys(clickedAllOrders).length > 0 && (



                            <div style={{ marginTop: '20px', width: '80%', marginLeft: '30px' }}>
                                <div style={{ marginLeft: '10px', fontFamily: 'Roboto', fontSize: '14px', color: '#929293', }}>
                                    Item{clickedAllOrders?.item_names?.length > 1 ? 's' : ''}
                                </div>
                                <div style={{ margin: '10px 10px 10px 15px', alignContent: 'center' }}>
                                    {clickedAllOrders?.item_name?.map((item, i) => {

                                        let price = 'Meal item'
                                        const displayPrice = (price === 'Meal item') ? 'Meal item' : `$${price}`;

                                        return (
                                            <div style={{ alignContent: 'center', marginBottom: '10px' }} key={`${item}_${i}`}>
                                                <div style={{ display: 'flex', flexDirection: 'row', alignText: 'center', alignContent: 'center' }}>

                                                    <div style={{
                                                        display: 'flex', fontFamily: 'Roboto Medium', fontSize: '11px', justifyContent: 'center', backgroundColor: '#e8e7e9', alignItems: 'center',
                                                        border: '1px solid #c7c7c7', borderRadius: '3px', height: '18px', width: '22px', margin: '0px 10px 5px 0px',
                                                    }}>{item.qty}</div>
                                                    <div style={{ display: 'flex', flexDirection: 'column', }}>
                                                        <div style={{ fontFamily: 'Roboto Medium', fontSize: '16px', color: '#181436', textTransform: 'capitalize' }}>{item.item}</div>
                                                        {item?.promotion && <div style={{ fontFamily: 'Roboto Regular', fontSize: '11px', color: '#BABABA', marginTop: '2px', marginBottom: '5px' }}>
                                                            Applied - <a style={{ fontFamily: 'Roboto Medium', fontSize: '11px', color: 'rgb(69, 165, 23)' }}> {TextTransformation(item?.promotion)}</a></div>}

                                                        {item?.product_category && <div style={{ fontSize: '12px', fontFamily: 'Inter Regular', color: 'lightgray' }}>Meal item</div>}

                                                    </div>
                                                    <div style={{ flex: 1, textAlign: 'right', fontFamily: 'Roboto Medium', fontSize: '14px', color: '#181436', }}> {price}</div>

                                                </div>
                                                {item?.extra_toppings?.map((t, j) => (
                                                    <div style={{ display: 'flex', flexDirection: 'row', margin: '0px 0px 0px 35px' }} key={t.topping_name}>
                                                        <div style={{ fontFamily: 'Roboto Regular', fontSize: '13px', color: '#181436', marginRight: '30px', textTransform: 'capitalize' }}>{`${t.topping_name} (${t.topping_qty})`}</div>
                                                        <div style={{ fontFamily: 'Roboto Regular', fontSize: '13px', color: '#181436', marginRight: '10px' }}>${(t.topping_qty * t.price).toFixed(2)}</div>

                                                    </div>
                                                ))}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}



                        <div style={{ margin: isIpad ? '10px 0px 20px 38%' : '10px 0px 20px 60%', width: isIpad ? '45%' : '22%', }}>

                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <div style={StyleTotalBlock}> Sub total</div>
                                <div style={StyleNumberBlock}> ${(clickedAllOrders?.sub_total || 0.00)?.toFixed(2)}</div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <div style={StyleTotalBlock}>  Delivery Fee</div>
                                <div style={StyleNumberBlock}> ${(clickedAllOrders?.delivery_price)?.toFixed(2) || (clickedAllOrders?.deliverySubscription_fee)?.toFixed(2)}</div>
                            </div>

                            {clickedAllOrders?.discount_coupon_no && <div>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <div style={StyleTotalBlock}>Discount</div>
                                    <div style={{ ...StyleNumberBlock, color: 'green' }}> {promoTypeLabel(clickedAllOrders?.discount_type, clickedAllOrders?.discountedAmount)}</div>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <div style={StyleTotalBlock}> Discount code</div>
                                    <div style={{ ...StyleNumberBlock, textTransform: 'uppercase' }}> {(clickedAllOrders?.discount_coupon_no)}</div>
                                </div>
                            </div>
                            }


                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <div style={StyleTotalBlock}>Tax & other fee</div>
                                <div style={StyleNumberBlock}> ${(clickedAllOrders?.tax_plus_serviceFees || clickedAllOrders?.tax)?.toFixed(2)}</div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <div style={StyleTotalBlock}>Tip</div>
                                <div style={StyleNumberBlock}> ${(clickedAllOrders?.tip)?.toFixed(2)}</div>
                            </div>

                            {clickedAllOrders?.promoOrderAmountAdded_In_Total_charged !== 0 && <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                marginTop: '10px'
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ ...StyleTotalBlock, fontSize: '13px' }}>Complimentary Item</div>
                                    <div style={{ fontSize: '12px', color: 'gray' }}> Packaging & Delivery Fee</div>
                                    <div style={{ fontSize: '12px', color: 'green' }}> Arriving Tomorrow</div>
                                </div>

                                <div style={StyleNumberBlock}> ${(clickedAllOrders?.promoOrderAmountAdded_In_Total_charged)?.toFixed(2)}</div>
                            </div>}


                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '10px' }}>
                                <div style={{ ...StyleTotalBlock, fontFamily: 'Inter Bold' }}>Total</div>
                                <div style={{ ...StyleNumberBlock, fontFamily: 'Inter Bold' }}> ${(clickedAllOrders?.total_charged)?.toFixed(2)}</div>
                            </div>



                        </div>



                        {clickedAllOrders?.internal_order_status === "order delivered" && <TransactionDetail />}


                    </div>
                }


            </div>




        </>
    )
}

export default AllOrders
